import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Products', path: '/products' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Blog', path: '/blog' },
    { name: 'Careers', path: '/careers' },
  ];

  const services = [
    { name: 'Dental Lab Services', path: '/services' },
    { name: 'Medical Testing', path: '/services' },
    { name: 'Manufacturing', path: '/services' },
    { name: 'Quality Control', path: '/services' },
    { name: 'Research & Development', path: '/services' },
    { name: 'Consulting', path: '/services' },
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', url: '#', label: 'Facebook' },
    { icon: 'ri-twitter-x-fill', url: '#', label: 'Twitter' },
    { icon: 'ri-linkedin-fill', url: '#', label: 'LinkedIn' },
    { icon: 'ri-instagram-fill', url: '#', label: 'Instagram' },
    { icon: 'ri-youtube-fill', url: '#', label: 'YouTube' },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-50 via-gray-100 to-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6 group">
              <img 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/71b4496442f888e58b7226680dc03ff3.png" 
                alt="Carver Dental Laboratory" 
                className="h-20 w-auto group-hover:scale-105 transition-transform duration-300"
                style={{ objectFit: 'contain' }}
              />
            </Link>
            <p className="text-darkgray-500 mb-6 leading-relaxed">
              Leading dental laboratory providing comprehensive dental prosthetics and restorative solutions with cutting-edge technology and expert craftsmanship.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  aria-label={social.label}
                  className="w-10 h-10 flex items-center justify-center bg-gray-200 text-darkgray-500 rounded-full hover:bg-gold-500 hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-display font-bold text-darkgray-500 mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-darkgray-500 hover:text-gold-600 transition-colors duration-300 inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-display font-bold text-darkgray-500 mb-6">Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className="text-darkgray-500 hover:text-gold-600 transition-colors duration-300 inline-block"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-display font-bold text-darkgray-500 mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-line text-gold-500 text-lg"></i>
                </div>
                <span className="text-darkgray-500 flex-1">
                  123 Dental Plaza, Healthcare District, New York, NY 10001
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-line text-gold-500 text-lg"></i>
                </div>
                <a href="tel:+1234567890" className="text-darkgray-500 hover:text-gold-600 transition-colors duration-300">
                  +1 (234) 567-890
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-line text-gold-500 text-lg"></i>
                </div>
                <a href="mailto:info@carverdentallab.com" className="text-darkgray-500 hover:text-gold-600 transition-colors duration-300">
                  info@carverdentallab.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-200 bg-white/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-darkgray-500 text-sm text-center md:text-left">
              © {currentYear} Carver Dental Laboratory. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-darkgray-500 hover:text-gold-600 text-sm transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-darkgray-500 hover:text-gold-600 text-sm transition-colors duration-300">
                Terms of Service
              </Link>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-darkgray-500 hover:text-gold-600 text-sm transition-colors duration-300"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
